import { Api } from './Api'

export const api = new Api({
  baseURL: '/api/',
  // baseURL: '//10.10.10.92:3000/',
  timeout: 60000,
})
